import React from 'react'
import { Link } from 'react-router-dom'

const MyAccountGuest = () => {
  return (
    <ul className='list-unstyled'>
      <li><Link to={{ pathname: '/login', search: window.location.search.substring(1) }}>Entrar</Link></li>
      <li><Link to={{ pathname: '/login', search: window.location.search.substring(1) }}>Criar uma conta</Link></li>
    </ul>
  )
}

export default MyAccountGuest
